import { render, staticRenderFns } from "./historyCulture.vue?vue&type=template&id=085def56&"
import script from "./historyCulture.vue?vue&type=script&lang=js&"
export * from "./historyCulture.vue?vue&type=script&lang=js&"
import style0 from "./historyCulture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports